import audio from '../audio';
import setVolumeToStorage from './setVolumeToStorage';

function setVolume(value) {
  audio.volume = value / 100;
  setVolumeToStorage(value);
}

export default setVolume;
